import { newGuid } from "@/assets/utils/guid";
import { PolicyConfiguration } from "../policy-configurations";
import { SeatingStrategyBase } from "../seating-strategies";
import { VenueTable } from "./venue-table";

export class VenueSection {
  constructor(id, name) {
    this.id = id ? id : newGuid();
    this.venueSectionId = { id: this.id};
    this.name = name;
    this.venueTables = [];
    this.image = undefined;
    this.description = undefined;
    this.created = undefined;
    this.deleted = undefined;
    this.venuePolicies = [];
    this.seatingStrategies = [];
    this.bookingOnRequestOnly = false;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    let section =  Object.assign(new VenueSection(), json);
    if(section.venuePolicies) {
      section.venuePolicies = section.venuePolicies.map(m => {
        return PolicyConfiguration.fromJSON(m);
      });
    }

    if(section.seatingStrategies) {
      section.seatingStrategies = section.seatingStrategies.map(m => {
        return SeatingStrategyBase.fromJSON(m);
      });
    }

    if(section.venueTables){
      section.venueTables = section.venueTables.map(m => {
        return VenueTable.fromJSON(m);
      });
    }
    return section;
  }
}

